// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../utils/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Desktop card ── */
.alert-cta-desktop {
  display: block;
}

.alert-cta-card {
  position: absolute;
  bottom: 24px;
  left: 24px;
  z-index: 10;
  background: var(--map-surface);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid var(--map-border);
  border-radius: 16px;
  box-shadow:
    0 0 24px rgba(225, 6, 19, 0.15),
    0 8px 32px rgba(0, 0, 0, 0.45);
  padding: 16px 18px;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.alert-cta-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.alert-cta-icon {
  font-size: 20px;
}

.alert-cta-title {
  color: var(--map-danger);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
}

.alert-cta-message {
  margin: 0;
  font-size: 13px;
  color: var(--map-text-muted);
  line-height: 1.55;
}

.alert-cta-message strong {
  color: var(--map-text-primary);
}

.alert-cta-divider {
  height: 1px;
  background: var(--map-border);
}

.alert-cta-close {
  background: transparent;
  border: 1px solid var(--map-border);
  border-radius: 50%;
  color: var(--map-text-muted);
  width: 22px;
  height: 22px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  margin-left: auto;
  line-height: 1;
  transition: border-color 0.2s, color 0.2s;
}

.alert-cta-close:hover {
  border-color: var(--map-danger);
  color: var(--map-text-primary);
}

/* ── FAB (single class for both desktop collapsed & mobile) ── */
.alert-fab {
  position: absolute;
  bottom: 24px;
  left: 24px;
  z-index: 100;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: var(--map-danger-gradient);
  color: white;
  font-size: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(225, 6, 19, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
}

.alert-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 24px rgba(225, 6, 19, 0.55);
}

.alert-fab:active {
  transform: scale(0.95);
}

/* ── Mobile modal ── */
.alert-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 20;
}

.alert-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 21;
  background: var(--map-surface);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid var(--map-border);
  border-radius: 20px 20px 0 0;
  padding: 24px 20px 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
}

.alert-modal-close {
  position: absolute;
  top: 14px;
  right: 18px;
  background: transparent;
  border: none;
  color: var(--map-text-muted);
  font-size: 18px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s, color 0.2s;
}

.alert-modal-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--map-text-primary);
}

.signup-submit-btn {
  margin-top: 0;
  border-radius: 24px;
  border: none;
  background: var(--map-danger-gradient);
  color: var(--map-text-primary);
  font-size: 13px;
  font-weight: 700;
  width: 96%;
  letter-spacing: 1.5px;
  padding: 13px 48px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
}

.signup-submit-btn:hover {
  opacity: 0.9;
}

.signup-submit-btn:active {
  transform: scale(0.97);
}

/* ── Responsive: hide desktop card on mobile ── */
@media (max-width: 767px) {
  .alert-cta-desktop {
    display: none;
  }
}

@media (max-width: 480px) {
  .alert-fab {
    bottom: 120px;
    left: 16px;
    width: 52px;
    height: 52px;
    font-size: 24px;
  }

  .alert-modal {
    padding: 28px 18px 40px;
  }
}

@media (max-width: 360px) {
  .alert-fab {
    bottom: 120px;
    left: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/alertCTA/AlertCTA.css"],"names":[],"mappings":"AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB;;kCAEgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,uCAAuC;EACvC,4BAA4B;EAC5B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,UAAU;EACZ;AACF","sourcesContent":["@import '../../../utils/colors.css';\n\n/* ── Desktop card ── */\n.alert-cta-desktop {\n  display: block;\n}\n\n.alert-cta-card {\n  position: absolute;\n  bottom: 24px;\n  left: 24px;\n  z-index: 10;\n  background: var(--map-surface);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid var(--map-border);\n  border-radius: 16px;\n  box-shadow:\n    0 0 24px rgba(225, 6, 19, 0.15),\n    0 8px 32px rgba(0, 0, 0, 0.45);\n  padding: 16px 18px;\n  max-width: 350px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.alert-cta-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.alert-cta-icon {\n  font-size: 20px;\n}\n\n.alert-cta-title {\n  color: var(--map-danger);\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n}\n\n.alert-cta-message {\n  margin: 0;\n  font-size: 13px;\n  color: var(--map-text-muted);\n  line-height: 1.55;\n}\n\n.alert-cta-message strong {\n  color: var(--map-text-primary);\n}\n\n.alert-cta-divider {\n  height: 1px;\n  background: var(--map-border);\n}\n\n.alert-cta-close {\n  background: transparent;\n  border: 1px solid var(--map-border);\n  border-radius: 50%;\n  color: var(--map-text-muted);\n  width: 22px;\n  height: 22px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  margin-left: auto;\n  line-height: 1;\n  transition: border-color 0.2s, color 0.2s;\n}\n\n.alert-cta-close:hover {\n  border-color: var(--map-danger);\n  color: var(--map-text-primary);\n}\n\n/* ── FAB (single class for both desktop collapsed & mobile) ── */\n.alert-fab {\n  position: absolute;\n  bottom: 24px;\n  left: 24px;\n  z-index: 100;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: var(--map-danger-gradient);\n  color: white;\n  font-size: 22px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(225, 6, 19, 0.4);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.alert-fab:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 24px rgba(225, 6, 19, 0.55);\n}\n\n.alert-fab:active {\n  transform: scale(0.95);\n}\n\n/* ── Mobile modal ── */\n.alert-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  z-index: 20;\n}\n\n.alert-modal {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 21;\n  background: var(--map-surface);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-top: 1px solid var(--map-border);\n  border-radius: 20px 20px 0 0;\n  padding: 24px 20px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from { transform: translateY(100%); }\n  to   { transform: translateY(0); }\n}\n\n.alert-modal-close {\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  background: transparent;\n  border: none;\n  color: var(--map-text-muted);\n  font-size: 18px;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s, color 0.2s;\n}\n\n.alert-modal-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--map-text-primary);\n}\n\n.signup-submit-btn {\n  margin-top: 0;\n  border-radius: 24px;\n  border: none;\n  background: var(--map-danger-gradient);\n  color: var(--map-text-primary);\n  font-size: 13px;\n  font-weight: 700;\n  width: 96%;\n  letter-spacing: 1.5px;\n  padding: 13px 48px;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s;\n}\n\n.signup-submit-btn:hover {\n  opacity: 0.9;\n}\n\n.signup-submit-btn:active {\n  transform: scale(0.97);\n}\n\n/* ── Responsive: hide desktop card on mobile ── */\n@media (max-width: 767px) {\n  .alert-cta-desktop {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .alert-fab {\n    bottom: 120px;\n    left: 16px;\n    width: 52px;\n    height: 52px;\n    font-size: 24px;\n  }\n\n  .alert-modal {\n    padding: 28px 18px 40px;\n  }\n}\n\n@media (max-width: 360px) {\n  .alert-fab {\n    bottom: 120px;\n    left: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
